<template>
  <div>
    <span>{{ errors.message }}</span>
    <ul>
      <template v-for="(error, index) in errors.errors">
        <li :key="index">{{ index }}
          <ul>
            <template v-for="errorMessage in error">
              <li :key="errorMessage">{{ errorMessage }}</li>
            </template>
          </ul>
        </li>
      </template>
    </ul>
  </div>

</template>

<script>
export default {
  name: "validation_errors",
  data() {
    return {}
  },
  props: ['errors', 'variant'],
  computed: {
    validationErrors() {
      let errors = Object.values(this.errors);
      errors = errors.flat();
      return errors;
    }
  }
}
</script>
